import { NgModule } from '@angular/core';
import {
  JumbotronContainerComponent,
  ShareButtonsContainerComponent,
} from '@innogy/knowledge-base/detail';
import { OverviewComponent } from '@innogy/knowledge-base/overview';
import { CategoryNavigationComponent } from '@innogy/knowledge-base/shared';
import { provideLazyLoad } from '@core/jss-utils';

@NgModule({
  imports: [
    provideLazyLoad({
      CategoryNavigation: CategoryNavigationComponent,
      Overview: OverviewComponent,
      JumbotronLegacy: JumbotronContainerComponent,
      ShareButtons: ShareButtonsContainerComponent,
    }),
  ],
})
export class KnowledgeBaseLazyModule {}
